<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <label v-if="label" class="value-toggle__label v-label theme--light">
                {{ label }}
            </label>
            <div class="value-toggle__row">
                <v-switch
                    v-if="type === 'switch'"
                    ref="input"
                    v-model="inputValue"
                    :value="emitValue"
                    :color="color"
                    class="value-toggle__switch"
                    dense
                    :rules="validators"
                    hide-details
                    :disabled="disabled"
                    :readonly="readonly"
                    :loading="loading"
                    @focus="$emit('focus')"
                    @blur="$emit('blur')"
                    @keyup="$emit('keyup')"
                    @keydown="$emit('keydown')"
                    @click="$emit('click')"
                />
                <v-checkbox
                    v-if="type === 'checkbox'"
                    ref="input"
                    v-model="inputValue"
                    :value="emitValue"
                    :color="color"
                    class="value-toggle__switch"
                    inset
                    dense
                    :rules="validators"
                    hide-details
                    :disabled="disabled"
                    :readonly="readonly"
                    :loading="loading"
                    @focus="$emit('focus')"
                    @blur="$emit('blur')"
                    @keyup="$emit('keyup')"
                    @keydown="$emit('keydown')"
                    @click="$emit('click')"
                />
                <label
                    v-if="description"
                    class="value-toggle__description text--secondary"
                    role="button"
                    @click="$refs.input.onClick()"
                    @keyup="$refs.input.onClick()"
                >
                    {{ description }}
                </label>
            </div>
            <v-input v-if="!hideDetails" v-model="inputValue" :error-messages="errorMessages" :rules="validators" />
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'ValueToggle',
    extends: Edit,
    props: {
        value: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: 'switch',
            validator: value => ['switch', 'checkbox', 'radio'].includes(value)
        },
        emitValue: {
            type: [String, Number, Boolean, Object, Array, Date],
            required: true
        },
        color: {
            type: String,
            default: 'success'
        }
    },
    computed: {
        classList() {
            let classList = ['value-toggle'];

            if (this.disabled) {
                classList.push('value-toggle--disabled');
            }

            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss">
.value-toggle {
    position: relative;

    &--form {
        margin-bottom: 1.5rem;
    }

    &--label {
        padding: 1rem 0 0;
    }

    &__label {
        transform: scale(0.75);
        position: absolute;
        top: 0;
        left: 0;
    }

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    &__switch {
        margin-top: 0;
        padding-top: 0.2rem;
        padding-left: 0.2rem;
    }

    &__description {
        font-size: 0.9rem;
        cursor: pointer;
    }

    &--disabled {
        .value-toggle {
            &__description {
                cursor: default;
            }
        }
    }
}
</style>
